/*
Front-end ICS generation for the confirmed-inspection "Add to calendar"
button (STREAM-38 v3). No backend involvement: we build a minimal VCALENDAR
blob and trigger a download. Times are emitted as UTC instants (Z suffix), so
calendar apps render them correctly in any timezone — including the property's.
*/

import moment from 'moment-timezone'

// RFC 5545 TEXT escaping: backslash, semicolon, comma, newline.
export const escapeIcsText = value =>
  String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\r?\n/g, '\\n')

const icsStamp = value => moment(value).utc().format('YYYYMMDD[T]HHmmss[Z]')

const DEFAULT_DURATION_MS = 2 * 60 * 60 * 1000

export const buildIcs = ({ start, end, summary, location, description, uid }) => {
  const endValue = end || moment(start).valueOf() + DEFAULT_DURATION_MS
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Reggora//Inspection Scheduling//EN',
    'BEGIN:VEVENT',
    'UID:' + (uid || icsStamp(moment())) + '@reggora.com',
    'DTSTAMP:' + icsStamp(moment()),
    'DTSTART:' + icsStamp(start),
    'DTEND:' + icsStamp(endValue),
    'SUMMARY:' + escapeIcsText(summary || 'Property inspection'),
  ]
  if (location) {
    lines.push('LOCATION:' + escapeIcsText(location))
  }
  if (description) {
    lines.push('DESCRIPTION:' + escapeIcsText(description))
  }
  lines.push('END:VEVENT')
  lines.push('END:VCALENDAR')
  return lines.join('\r\n')
}

export const downloadIcs = (ics, filename) => {
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename || 'inspection.ics'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 60000)
}
